import { nextTick, onBeforeUnmount, watchPostEffect, type Ref } from 'vue'
import { logErrorOnSentry } from '@/utils/errorReportingUtils.js'

const sections = new Set(['section-gallery', 'section-itinerary', 'section-accommodation', 'section-addon'])

export function useItinerarySectionLink(ready: Readonly<Ref<boolean>>): void {
  let attempted = false
  let disposed = false
  let timer: ReturnType<typeof setTimeout> | undefined
  onBeforeUnmount(() => {
    disposed = true
    clearTimeout(timer)
  })
  watchPostEffect(() => {
    if (!ready.value || attempted) return
    attempted = true
    const section = window.location.hash.slice(1)
    if (!sections.has(section)) return
    const slug = new URLSearchParams(window.location.search).get('gallery_photo')
    void nextTick(() => {
      if (disposed) return
      const element = document.getElementById(section)
      element?.scrollIntoView({ block: 'start' })
      if (!element || !slug) return
      let retries = 100
      const openPhoto = () => {
        if (disposed) return
        const anchor = Array.from(
          element.querySelectorAll<HTMLAnchorElement>('a[data-fslightbox][data-medium-wrapper-slug]'),
        ).find(image => image.dataset.mediumWrapperSlug === slug)
        if (!anchor) return
        // fslightbox assigns onclick when it registers each source, including hidden photos.
        // Wait for that registration rather than navigating to the raw href before it is ready.
        if (typeof anchor.onclick !== 'function') {
          if (retries-- > 0) timer = setTimeout(openPhoto, 50)
          return
        }
        try {
          anchor.click()
        } catch (error) {
          logErrorOnSentry(error, { component: 'Itinerary', function: 'openLinkedGalleryPhoto' })
        }
      }
      openPhoto()
    })
  })
}
